import { render, staticRenderFns } from "./GroupLevelAttributeEmailField.vue?vue&type=template&id=f4ff23ca&"
import script from "./GroupLevelAttributeEmailField.vue?vue&type=script&lang=ts&"
export * from "./GroupLevelAttributeEmailField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports